/* unplugin-vue-components disabled */import { render } from "./fujianshifanType.vue?vue&type=template&id=064e0e70&scoped=true"
import script from "./fujianshifanType.vue?vue&type=script&lang=js"
export * from "./fujianshifanType.vue?vue&type=script&lang=js"

import "./fujianshifanType.vue?vue&type=style&index=0&id=064e0e70&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064e0e70"]])

export default __exports__